module.exports = __webpack_public_path__ + "static/media/115.be06a32b.jpg";